import ResponsiveImage from "../responsive-image/ResponsiveImage";
import React from "react";
import { useTranslation } from "react-i18next";
import firstThumbnail from "./images/youtube-fsekHU2B0FU.jpg";
import secondThumbnail from "./images/youtube-9meVRWltngI.jpg";
import thirdThumbnail from "./images/youtube-to374ErhWjQ.jpg";
import "./VideoTiles.css";

const videos = [
  { id: "fsekHU2B0FU", thumbnail: firstThumbnail },
  { id: "9meVRWltngI", thumbnail: secondThumbnail },
  { id: "to374ErhWjQ", thumbnail: thirdThumbnail },
];

const VideoTiles = () => {
  const { t } = useTranslation();

  return (
    <section className="analysis-videos" aria-labelledby="analysis-videos-title">
      <h2 id="analysis-videos-title">{t("analyseDocument:videos_title")}</h2>
      <div className="analysis-videos__grid">
        {videos.map((video, index) => (
          <a
            key={video.id}
            className="analysis-videos__tile"
            href={`https://www.youtube.com/watch?v=${video.id}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("analyseDocument:video_link_label", { number: index + 1 })}
          >
            <div className="analysis-videos__preview">
              <ResponsiveImage sizes="(max-width: 768px) 92vw, (max-width: 1680px) 30vw, 500px"
                src={video.thumbnail}
                alt=""
                width="1280"
                height="720"
                loading="lazy"
                decoding="async"
              />
              <svg
                className="analysis-videos__play"
                viewBox="0 0 88 62"
                aria-hidden="true"
                focusable="false"
              >
                <rect width="88" height="62" rx="14" fill="#ff0000" />
                <path d="M35 17L59 31L35 45Z" fill="#fff" />
              </svg>
            </div>
            <span className="analysis-videos__label">
              {t("analyseDocument:video_watch")}
              <span aria-hidden="true">↗</span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default VideoTiles;
